import { useEffect } from "react";
import { useLocalStorageVariable } from "2g-hooks";
import { useDataLoader } from "2g-hooks/fetch/";
import { DATA } from "b2b/api/paths";

export default function useTypyZdroje() {
  const [state = {}, setState] = useLocalStorageVariable("typyZdroje.state");

  const loader = useDataLoader({
    url: DATA.typyZdroje(),
    method: "get"
  });

  // useEffect(() => {
  //   !state.loaded && loader.load();
  // }, []);

  useEffect(() => {
    if (loader.loaded) {
      setState({
        data: loader.data,
        error: loader.error,
        loaded: loader.loaded
      });
    }
  }, [loader.data, loader.error, loader.loaded]);

  return { ...state, loading: loader.loading, reload: loader.reload };
}
